import React, { useState, useEffect } from 'react';
import { Typography, Paper, CircularProgress, Box, Grid } from '@mui/material';
import authService from 'services/authService';

const ManualDoSistema = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true); // Adicionando estado de carregamento

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        setLoading(true); // Começa carregando
        const userProfile = await authService.getProfile();
        
        // Verifica se o perfil existe e o define
        if (userProfile && userProfile.perfil) {
          setProfile(userProfile.perfil);
        } else {
          console.error('Perfil não encontrado na resposta:', userProfile);
        }
      } catch (error) {
        console.error('Erro ao buscar perfil do usuário:', error);
      } finally {
        setLoading(false); // Finaliza o carregamento
      }
    };

    fetchUserProfile();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    ); // Mostra um indicador de carregamento centralizado
  }

  return (
		<Grid sx={{ minHeight: '85vh' }}>
    <Paper sx={{ padding: 4, margin: 4, backgroundColor: '#f9f9f9', width: '75%', mx: 'auto',}}>
      {profile === 3 && (
        <>
          <Typography variant="body1" paragraph>
            Este é o administrador do Observatório do Crack. Aqui você pode:
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Gerenciar Usuários:</strong> Adicionar, editar e excluir usuários do sistema.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Analisar e Responder Solicitações:</strong> Analisar e responder a solicitações de novos usuários.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Gerenciar Perguntas:</strong> Adicionar, editar e excluir perguntas.
          </Typography>
        </>
      )}

      {profile === 1 && (
        <Typography variant="body1" paragraph>
          <strong>RESPONDA A PESQUISA</strong>
        </Typography>
      )}

      {profile === null && (
        <Typography variant="body1" paragraph>
          Perfil não encontrado ou usuário não autenticado.
        </Typography>
      )}
    </Paper>

		</Grid>
  );
};

export default ManualDoSistema;
